import * as React from "react";
import { styled } from "@mui/system";
import MUIOutlinedInput, {
  OutlinedInputProps,
} from "@mui/material/OutlinedInput";

type Props = {
  readOnly?: boolean;
} & OutlinedInputProps;

export const OutlinedInput = styled(
  (props: Props) => (
    <MUIOutlinedInput
      sx={{
        "& legend": {
          display: "none",
        },
        backgroundColor:
          props.readOnly && "primary.inputBackgroundReadonlyColor",
      }}
      {...props}
    />
  ),
  {
    name: "OutlinedInput",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    top: "-1px",
    height: "40px",
  },
}));
